import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";
import styled from "styled-components";
import moment from "moment";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { DataContext } from "../../contexts/DataContext";
import { FiPlay } from "react-icons/fi";
import { AiOutlinePause } from "react-icons/ai";
import { Button } from "../../Theme/Hyper";
import { APIContext } from "../../contexts/APIContext";
import { useHistory, useLocation } from "react-router";
import { VizContext } from "../../contexts/VizContext";
import { ClockContext } from "../../contexts/ClockContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { ControlContext } from "../../contexts/ControlContext";

const Main = styled.div`
  display: flex;
  font-weight: 100;

  width: 100%;
  align-items: center;
  flex-direction: column;
  margin-top: 0.5em;
  padding-bottom: 0.5em;
  z-index: 0;
`;
const ClockSection = styled.div`
  display: flex;
  min-width: 70px;
  height: 90px;
  justify-content: ${(props) => (props.mins ? "flex-end" : "flex-start")};
`;
const ClockSplit = styled.div`
  height: 90px;
`;
const Half = styled.div`
  display: flex;
  font-size: 1.5em;
`;

const ClockContainer = styled.div`
  display: flex;
  font-size: 4em;
  align-items: center;
  width: 100%;
`;
const Buttons = styled.div`
  display: flex;
  width: 100%;
  padding: 0.5em;
  box-sizing: border-box;
`;
const ClockButton = styled.div`
  font-size: 2em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  background-color: ${(props) => (props.green ? "#0adb93" : "#db0a41")};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  /* width: 100%; */
  justify-content: center;
  margin: 0.2em;
  width: 100%;
`;

const CentrePassButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 30%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 50px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;

const EnabledButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 35px;
  width: 100px;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;

const ClockDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export default function ClockStream({
  game,
  teams,
  previewGraphic,
  animateGraphic,
  animateOffGraphic,
  updateGraphic,
  triggerAnimation,
  setGameState,
  GameState,
}) {
  const { vizSharedMemory } = useContext(VizContext);
  const { auto_clock, period } = useContext(ClockContext);
  const { update } = useContext(ControlContext);
  const { homeKit, awayKit, homeScore, awayScore, localPeriod, scoringMode, extraTimeToggle, clockHide } =
    useContext(UIContext);
  const [mode] = useLocalStorage("hyper-netball-gfx-mode", "viz");
  const [ssEnabled, setSSEnabled] = useLocalStorage(
    "hyper-netball-gfx-ss-enabled",
    true
  );
  const [autoEnabled, setAutoEnabled] = useLocalStorage(
    "hyper-netball-gfx-auto-enabled",
    true
  );
  const [ssGoalAnimEnabled, setSSGoalAnimEnabled] = useLocalStorage(
    "hyper-netball-gfx-ss-goal-anim-enabled",
    true
  );
  const history = useHistory();
  const location = useLocation();
  const [clock, setClock] = useState();

  useEffect(() => {
    update(
      "NB_LIMA4_ScoreClock",
      [
        {
          name: "SuperShotGRP",
          value: { visible: ssEnabled },
        },
      ],
      false
    );
  }, [ssEnabled]);
  useEffect(() => {
    updateGraphic("CLOCK", {
      auto_enabled: autoEnabled,
      SSGoalAnim: ssGoalAnimEnabled,
    });
  }, [autoEnabled, ssGoalAnimEnabled]);
  function getHalfText(number) {
    if (number === 1) {
      return "1st Q";
    } else if (number === 2) {
      return "2nd Q";
    } else if (number === 3) {
      return "3rd Q";
    } else if (number === 4) {
      return "4th Q";
    } else if (number === 5) {
      return "ET1";
    } else if (number === 6) {
      return "ET2";
    }
    return number;
  }

  return (
    <Main>
      {game && period && <Half>{getHalfText(period)}</Half>}

      <ClockContainer>
        <ClockDiv>
          <ClockSection>{auto_clock}</ClockSection>
        </ClockDiv>
      </ClockContainer>

      <Column>
        <Buttons>
          <ClockButton
            onClick={() => {
              animateOffGraphic("CLOCK", {});
            }}
          >
            CLOCK OUT
          </ClockButton>

          <ClockButton
            onClick={() => {
              update(
                "NB_LIMA4_ScoreClock",
                [
                  {
                    name: "SuperShotGRP",
                    value: { visible: ssEnabled },
                  },
                ],
                false
              );
              setGameState("Match");
              animateGraphic("CLOCK", {
                teams: teams,
                game: game,
                clock: clock,
                period: period,
                homeKit,
                awayKit,
                homeScore: homeScore?.game === game?._id ? homeScore?.score : 0,
                awayScore: awayScore?.game === game?._id ? awayScore?.score : 0,
                period:
                  localPeriod?.game === game?._id ? localPeriod?.period : "",
                mode: scoringMode?.game === game?._id ? scoringMode?.mode : "",
                clockHide: clockHide?.game === game?._id ? clockHide?.clockvis : "show",
                show_super_shot: ssEnabled,
                auto_enabled: autoEnabled,
                SSGoalAnim: ssGoalAnimEnabled,
                extraTimeToggle: extraTimeToggle?.game === game?._id ? extraTimeToggle?.etmode : "false",
                analysisperiod: ""
              });
            }}
            green
          >
            CLOCK IN
          </ClockButton>
        </Buttons>
        </Column>
        Analysis Clocks
        <Column>
          <Buttons  style={{height: "50px"}}>
          <ClockButton
            onClick={() => {
              animateOffGraphic("CLOCK", {});
            }}
          >
            OUT
          </ClockButton>

          <ClockButton
            onClick={() => {
              update(
                "NB_LIMA4_ScoreClock",
                [
                  {
                    name: "SuperShotGRP",
                    value: { visible: ssEnabled },
                  },
                ],
                false
              );
              setGameState("Match");
              animateGraphic("CLOCK", {
                teams: teams,
                game: game,
                clock: clock,
                period: period,
                homeKit,
                awayKit,
                homeScore: homeScore?.game === game?._id ? homeScore?.score : 0,
                awayScore: awayScore?.game === game?._id ? awayScore?.score : 0,
                period:
                  localPeriod?.game === game?._id ? localPeriod?.period : "",
                mode: scoringMode?.game === game?._id ? scoringMode?.mode : "",
                show_super_shot: ssEnabled,
                auto_enabled: autoEnabled,
                SSGoalAnim: ssGoalAnimEnabled,
                extraTimeToggle: extraTimeToggle?.game === game?._id ? extraTimeToggle?.etmode : "false",
                analysisperiod: "Half-Time"
              });
            }}
            green
          >
            HT CLOCK
          </ClockButton>
          <ClockButton
            onClick={() => {
              update(
                "NB_LIMA4_ScoreClock",
                [
                  {
                    name: "SuperShotGRP",
                    value: { visible: ssEnabled },
                  },
                ],
                false
              );
              setGameState("Match");
              animateGraphic("CLOCK", {
                teams: teams,
                game: game,
                clock: clock,
                period: period,
                homeKit,
                awayKit,
                homeScore: homeScore?.game === game?._id ? homeScore?.score : 0,
                awayScore: awayScore?.game === game?._id ? awayScore?.score : 0,
                period:
                  localPeriod?.game === game?._id ? localPeriod?.period : "",
                mode: scoringMode?.game === game?._id ? scoringMode?.mode : "",
                show_super_shot: ssEnabled,
                auto_enabled: autoEnabled,
                SSGoalAnim: ssGoalAnimEnabled,
                extraTimeToggle: extraTimeToggle?.game === game?._id ? extraTimeToggle?.etmode : "false",
                analysisperiod: "Final Score"
              });
            }}
            green
          >
            FT CLOCK
          </ClockButton>
        </Buttons>
      </Column>
      <Column style={{ justifyContent: "center", alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
          Centre Pass -  Auto Switch{" "}
              <EnabledButton
                green={autoEnabled}
                onClick={() => {
                  setAutoEnabled(true);
                }}
              >
                Enabled
              </EnabledButton>
              <EnabledButton
                green={!autoEnabled}
                onClick={() => {
                  setAutoEnabled(false);
                }}
              >
                Disabled
              </EnabledButton>
        </div>

        <Buttons style={{ justifyContent: "center", alignItems: "center" }}>
          <CentrePassButton
            onClick={() => {
              if (mode === "hyper") {
                previewGraphic("CentrePass", {
                  side: "home",
                });
              } else if (mode === "viz") {
                vizSharedMemory({
                  shared_memory: "SMMSystem_SetValue|CentrePass|1",
                });
              }
            }}
          >
            HOME
          </CentrePassButton>

          <CentrePassButton
            onClick={() => {
              if (mode === "hyper") {
                previewGraphic("CentrePass", {
                  side: "away",
                });
              } else if (mode === "viz") {
                vizSharedMemory({
                  shared_memory: "SMMSystem_SetValue|CentrePass|0",
                });
              }
            }}
          >
            AWAY
          </CentrePassButton>

          <CentrePassButton
            onClick={() => {
              if (mode === "hyper") {
                previewGraphic("CentrePass", {
                  side: "hide",
                });
              } else if (mode === "viz") {
              }
            }}
          >
            HIDE
          </CentrePassButton>
        </Buttons>
      </Column>
      {mode === "hyper" && (
        <Column style={{ justifyContent: "center", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            Super Shot{" "}
            <div style={{ display: "flex" }}>
              <EnabledButton
                green={ssEnabled}
                onClick={() => {
                  setSSEnabled(true);
                }}
              >
                Enabled
              </EnabledButton>
              <EnabledButton
                green={!ssEnabled}
                onClick={() => {
                  setSSEnabled(false);
                }}
              >
                Disabled
              </EnabledButton>
            </div>
          </div>

          <Buttons style={{ justifyContent: "center", alignItems: "center" }}>
            <CentrePassButton
              onClick={() => {
                if (mode === "hyper") {
                  triggerAnimation("NB_LIMA4_ScoreClock", [], "SS-IN");
                }
              }}
            >
              IN
            </CentrePassButton>

            <CentrePassButton
              onClick={() => {
                if (mode === "hyper") {
                  triggerAnimation("NB_LIMA4_ScoreClock", [], "SS-OUT");
                }
              }}
            >
              OUT
            </CentrePassButton>
          </Buttons>
          <div style={{ display: "flex", alignItems: "center" }}>
            Super Shot Goal Animation{" "}
            <div style={{ display: "flex" }}>
              <EnabledButton
                green={ssGoalAnimEnabled}
                onClick={() => {
                  setSSGoalAnimEnabled(true);
                }}
              >
                Enabled
              </EnabledButton>
              <EnabledButton
                green={!ssGoalAnimEnabled}
                onClick={() => {
                  setSSGoalAnimEnabled(false);
                }}
              >
                Disabled
              </EnabledButton>
            </div>
          </div>
        </Column>
      )}
    </Main>
  );
}
